import './src/utils/fonts.css';
import './src/utils/animations.css';

export const onClientEntry = () => {
  const metaTags = [
    { name: 'color-scheme', content: 'light' },
    { name: 'supported-color-schemes', content: 'light' },
    { name: 'theme-color', content: '#FFFFFF' }
  ];

  metaTags.forEach(tag => {
    const meta = document.createElement('meta');
    meta.name = tag.name;
    meta.content = tag.content;
    document.head.appendChild(meta);
  });
};
